import React from 'react';
import { Button, Card, Typography, Divider } from 'antd';
import { FilePdfOutlined, EyeOutlined } from '@ant-design/icons';

const { Text } = Typography;

export default function ActionsSection({
  loadedInvoice,
  loading,
  draftLoading,
  previewLoading,
  handleSaveDraft,
  handleDownloadPdf,
  handlePreviewPdf,
  subtotal,
  taxes,
  total,
  disableStamp,
}) {
  return (
    <>
      {/* Desglose de Impuestos */}
      <Card title="Resumen" style={{ marginBottom: '24px' }}>
        <div style={{ marginBottom: '16px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
            <Text>Subtotal:</Text>
            <Text strong>${subtotal?.toFixed(2) || '0.00'}</Text>
          </div>
          
          {taxes && taxes.length > 0 && (
            <>
              <Divider style={{ margin: '8px 0' }} />
              {taxes.map((tax, index) => (
                <div key={index} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                  <Text type="secondary">
                    {tax.tax_name} ({tax.tax_type === 'traslado' ? '+' : '-'}):
                  </Text>
                  <Text type="secondary">
                    ${tax.amount?.toFixed(2) || '0.00'}
                  </Text>
                </div>
              ))}
              <Divider style={{ margin: '8px 0' }} />
            </>
          )}
          
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '8px' }}>
            <Text strong style={{ fontSize: '16px' }}>Total:</Text>
            <Text strong style={{ fontSize: '16px', color: '#1890ff' }}>
              ${total?.toFixed(2) || '0.00'}
            </Text>
          </div>
        </div>
      </Card>

      {/* Botones de Acción */}
      <Card>
        <Button
          icon={<EyeOutlined />}
          onClick={handlePreviewPdf}
          style={{ width: '100%', marginBottom: '8px' }}
          loading={previewLoading}
        >
          Vista previa
        </Button>

        {loadedInvoice?.status === 'borrador' ? (
          <>
            <Button
              icon={<FilePdfOutlined />}
              onClick={handleDownloadPdf}
              style={{ width: '100%', marginBottom: '8px' }}
            >
              Descargar PDF
            </Button>
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              loading={loading}
              disabled={disableStamp}
              style={{ width: '100%' }}
            >
              Facturar
            </Button>
          </>
        ) : (
          <>
            <Button
              type="default"
              size="large"
              onClick={handleSaveDraft}
              loading={draftLoading}
              style={{ width: '100%', marginBottom: '8px' }}
            >
              Guardar borrador
            </Button>
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              loading={loading}
              disabled={disableStamp}
              style={{ width: '100%' }}
            >
              Facturar
            </Button>
          </>
        )}
      </Card>
    </>
  );
}
